/* Panel placement only. hera-site-visual-v5.js owns exclusive click/keyboard state. */
(() => {
  const updatePanelTop = () => {
    const header = document.querySelector('.header-wrapper');
    if (header) document.documentElement.style.setProperty('--hera-nav-panel-top', `${Math.max(0, Math.round(header.getBoundingClientRect().bottom))}px`);
  };
  updatePanelTop();
  window.addEventListener('resize', updatePanelTop, { passive: true });
  window.addEventListener('scroll', updatePanelTop, { passive: true });
})();
